module.exports = __webpack_public_path__ + "static/media/CWRU_School-of-Medicine_Logo.bbc3979a.png";